/**
 * Real `@itk-wasm/downsample` (official, pre-built WASM, v2.0.2) run against
 * a volume already in memory. The pipeline `.wasm` is fetched lazily by the
 * package itself (jsDelivr CDN, `getPipelinesBaseUrl()`'s default) only on
 * the first actual call below -- nothing is fetched just by importing this
 * module. itk-wasm's own `WorkerPoolFunctionOption` plumbing already runs
 * the computation off the main thread; no extra Worker needed here.
 */
import { downsample } from "@itk-wasm/downsample";

import type { NiftiVolume } from "@/lib/nifti";
import { itkImageToNiftiVolume, niftiVolumeToItkImage } from "./itkImage";

export async function downsampleVolume(vol: NiftiVolume, shrinkFactors: [number, number, number]): Promise<NiftiVolume> {
  const input = niftiVolumeToItkImage(vol, "input");
  const { downsampled } = await downsample(input, { shrinkFactors });
  return itkImageToNiftiVolume(downsampled);
}
